/**
 * 日報の報告文（LINE へ貼る下書き）を組み立てる。DAILY-WORKFLOW-4。
 *
 * ## ★この関数が受け取れるものを絞ってある
 *
 * 引数は**営業日・登録済みの売上・振り返りの本文**だけ。
 * 従業員氏名も時給も人件費も、そもそも渡せない（絶対ルール1）。
 * 「混ぜないように気をつける」ではなく、**混ぜられない形**にしてある。
 *
 * ## ★OCR の読取候補は使わない
 *
 * 読取候補は「画像から読めたかもしれない値」で、業務へ登録された値ではない。
 * 報告文に出してよいのは登録済みのデータだけなので、呼び出し側は
 * `daily_sales` から来た値を渡す（`docs/05` §3.1 の日報の注記）。
 *
 * ## ★未登録を 0 にしない
 *
 * 売上が無い日は「未登録」と書く。0円と書くと、読んだ人には
 * 「売上0円の日」と区別がつかない（CLAUDE.md 絶対ルール5 と同じ考え方）。
 *
 * ## ★送信はしない
 *
 * 文面を作るだけ。コピーしたことを「報告済み」とは扱わない（`docs/05` §3.1）。
 */

/** 報告文に出せる売上。★この形以外は受け取れない */
export interface ReportSales {
  salesInclTaxDinner: number;
  guestsDinner: number;
  groupsDinner: number;
  cashAmount: number;
  cardAmount: number;
  otherAmount: number;
}

const yen = (value: number): string => `${value.toLocaleString("ja-JP")}円`;

export function buildDailyReportText(input: {
  businessDate: string;
  /** 登録済みの売上。まだ登録していなければ `null` */
  sales: ReportSales | null;
  /** 保存済みの振り返り。未保存・空なら `null` */
  comment: string | null;
}): string {
  const lines = [`【${input.businessDate} 営業報告】`];

  if (input.sales === null) {
    lines.push("売上：未登録");
  } else {
    const s = input.sales;
    lines.push(`売上（税込）：${yen(s.salesInclTaxDinner)}`);
    lines.push(`内訳：現金 ${yen(s.cashAmount)} ／ カード ${yen(s.cardAmount)} ／ その他 ${yen(s.otherAmount)}`);
    lines.push(`客数：${s.guestsDinner.toLocaleString("ja-JP")}人（${s.groupsDinner.toLocaleString("ja-JP")}組）`);
  }

  lines.push("");
  lines.push("振り返り：");
  lines.push(input.comment === null || input.comment.trim() === "" ? "（未保存）" : input.comment);
  return lines.join("\n");
}
